// Mirrors backend compute_host_splits (server.py).
export function computeSplits(n, noFee = false) {
  if (n <= 0) return { platform: 100, showrunner: 0, other: 0 };
  if (noFee) return { platform: 0, showrunner: 100 / n, other: 100 / n };
  if (n === 1) return { platform: 10, showrunner: 90, other: 0 };
  const each = 60 / n;
  return { platform: 30, showrunner: each + 10, other: each };
}

export const pct = (v) => `${Number.isInteger(v) ? v : v.toFixed(1)}%`;

export function splitLabel(n, noFee = false) {
  if (n === 0) return "no hosts assigned";
  const s = computeSplits(n, noFee);
  if (noFee) return n === 1 ? "Host 100% · no network fee" : `Even split ${pct(s.other)} each · no network fee`;
  if (n === 1) return "Host 90% · Network 10%";
  return `Showrunner ${pct(s.showrunner)} · Co-hosts ${pct(s.other)} each · Network 30%`;
}
